export const getErrors = (state) => state.errorList;
export const getFatalError = (state) => state.fatalError;
